import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Joyride from "react-joyride";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Chip,
  ClickAwayListener,
  Divider,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Stack,
  Tooltip,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "ui-component/cards/MainCard";
import Transitions from "ui-component/extended/Transitions";

// assets
import {
  IconLogout,
  IconSettings,
  IconUsers,
  IconBuildingBank,
  IconSettingsAutomation,
} from "@tabler/icons";
import { LOGOUT, MENU_SELECT, TOUR_LOCATION } from "store/actions";
import axios from "axios";
import AppConfig from "api/AppConfig";
import useDataPostFunction from "hooks/useDataPostFunction";
import { hiredrateBridgeURL } from "store/hiredrateConst";
import { AD_ID } from "store/constant";
import {
  setSteps,
  stopTour,
  setStepIndex,
  setTourLocation,
  resetTour,
} from "store/tourSlice";
import { updateTourUrlConstruct } from "api/hiredrateURLConstruct";
import { RESET_COMMON_FILTER } from "store/filter/commonFilterReducer";
import { RESET_JOBPOSITION_FILTER } from "store/filter/jobpositionFilterReducer";
import { RESET_APPLICATION_FILTER } from "store/filter/jobApplicationFilterReducer";
import { RESET_APPLICATION_FILTER_JP } from "store/filter/jobApplicationByJPFilter";
import { RESET_MATCH_ANALYSIS_FILTER } from "store/filter/matchAnalysisFilterReducer";
import { RESET_MATCH_ANALYSIS_FILTER_JP } from "store/filter/matchAnalysisByJPFilterReducer";
import { useMediaQuery } from "@mui/material";
// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = ({ handleMenuClick, runTour, setRunValue }) => {
  const theme = useTheme();
  const customization = useSelector((state) => state.customization);
  const user_info = useSelector((state) => state.account.userData);
  const companyName = useSelector((state) => state?.account?.companyName) || "";
  const { userLogo } = useSelector((state) => state.account);
  const { endDate } = useSelector((state) => state.account);
  const endDateValue = new Date(endDate);
  const currentDate = new Date();
  // const isDatePassed = currentDate >= endDateValue;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const dispatcher = useDispatch();
  const navigate = useNavigate();
  const { menuItem } = useSelector((state) => state.account);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  const { run, steps, isTourOpen } = useSelector((state) => state.tour);
  const anchorRef = useRef(null);
  const { token } = useSelector((state) => state.account);
  const { companyID, sessionID } = useSelector((state) => state.account);
  const profileLoadType = "sg";
  const statedata = useSelector((state) => state);
  const [checked, setChecked] = useState(false);

  const configObject = AppConfig("APIConfig");

  const planName = useSelector((state) => state.account.planName);

  const isBasicPlan =
    (planName && planName.trim().toLowerCase() === "basic") ||
    endDate === false;

  const isDatePassed =
    !isBasicPlan &&
    endDate &&
    endDate !== false &&
    new Date() >= new Date(endDate);

  const [
    loggedOutResp,
    loggedOutRespError,
    loggedOutRespLoading,
    loggedOutFunc,
    logoutRespDetailedError,
    logoutrespReset,
  ] = useDataPostFunction();

  const logoutSession = (data) => {
    loggedOutFunc({
      axiosInstance: axios,
      method: "post",
      url: hiredrateBridgeURL() + "/v1/auth/logout",
      data: data,
      requestConfig: configObject,
    });
  };

  useEffect(() => {
    if (
      loggedOutResp?.status === 200 &&
      loggedOutResp?.data?.message === "Logout successful"
    ) {
      logoutrespReset();
    }
  }, [loggedOutResp]);

  const resetState = () => {
    dispatcher({
      type: MENU_SELECT,
      payload: {
        menuItem: "Job Positions",
      },
    });
    dispatcher(resetTour());

    dispatcher({ type: RESET_COMMON_FILTER });
    dispatcher({ type: RESET_JOBPOSITION_FILTER });
    dispatcher({ type: RESET_APPLICATION_FILTER });
    dispatcher({ type: RESET_APPLICATION_FILTER_JP });
    dispatcher({ type: RESET_MATCH_ANALYSIS_FILTER });
    dispatcher({ type: RESET_MATCH_ANALYSIS_FILTER_JP });
    dispatcher({ type: LOGOUT });
  };

  const handleLogout2 = async () => {
    sessionStorage.removeItem("modalClosed");
    const data = {
      "session-key": sessionID,
    };
    logoutSession(data);
    resetState();
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    // Prevent closing during tour
    if (isTourOpen) {
      return;
    }
    setOpen(false);
  };

  if (user_info == null) {
    dispatcher({ type: LOGOUT });
  }

  const handleListItemClick = (event, index, route = "") => {
    setSelectedIndex(index);
    handleClose(event);
    if (index == 0) {
      navigate("/settings/" + profileLoadType + "/user-profile/" + token);
    } else if (index == 9) {
      navigate("/settings/subscription");
    }
      else if (index == 1) {
      navigate("/settings/user-settings");
    } else if (index == 2) {
      navigate("/settings/company-profile/" + companyID);
    } else if (index == 7) {
      navigate("/colors");
    } else if (index == 6) {
      navigate("/settings/hiredrate-settings");
    }
    dispatcher({
      type: MENU_SELECT,
      payload: {
        menuItem: index,
      },
    });
    handleMenuClick();
  };

  const handleClickToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const handleCheckboxChange = (e) => {
    const value = e.target.checked;
    setChecked(value);
  };

  // Set tour steps with detailed logging
  useEffect(() => {
    if (user_info?.role_name === "Org Admin") {
      // Check if elements exist before setting steps
      const profileChip = document.querySelector(".profile-chip");
      const usersList = document.querySelector(".users-list");

      const tourSteps = [
        {
          target: "body",
          placement: "center",
          disableBeacon: true,
          content: (
            <div
              style={{
                textAlign: "left",
                marginTop: "10px",
                height: "110px",
                padding: "12px",
              }}
            >
              <Typography variant="h2" gutterBottom>
                Welcome to HIREdrate
              </Typography>
              <Typography variant="hdSubtitle1">
                Let's take a quick tour to get you started
              </Typography>
              <div style={{ marginTop: "40px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Don't show this tour again"
                />
              </div>
            </div>
          ),
        },
        {
          target: ".profile-chip",
          placement: "bottom",
          content: (
            <div
              style={{ textAlign: "left", marginTop: "30px", padding: "10px" }}
            >
              <Typography variant="hdSubtitle1">
                Click here to access your settings, including adding users
              </Typography>
            </div>
          ),
        },
        {
          target: ".users-list",
          placement: "bottom",
          content: (
            <div
              style={{ textAlign: "left", marginTop: "30px", padding: "10px" }}
            >
              <Typography variant="hdSubtitle1">
                This is where you manage and create users
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Click 'Continue' to proceed to the next step.
              </Typography>
            </div>
          ),
        },
        {
          target: ".users-list",
          placement: "bottom",
          content: (
            <div
              style={{ textAlign: "left", marginTop: "30px", padding: "10px" }}
            >
              <Typography variant="hdSubtitle1">
                Click 'Continue' to navigate to the Users page
              </Typography>
              <br />
              <Typography variant="body2" sx={{ mt: 1 }}>
                You will be redirected to the 'Users' management page
              </Typography>
            </div>
          ),
        },
        {
          target: ".user",
        },
      ];

      dispatcher(setSteps(tourSteps));
    }
  }, [dispatcher, user_info, checked]);

  // Enhanced handleTourEnd with comprehensive logging and element waiting
  const isUpdatingTour = useRef(false);

  const handleTourEnd = async (data) => {
    const { index, type, status, action } = data;

    //**^^** RECRUITER MANAGER **^^**//
    if (user_info?.role_name === "Recruiter Manager") {
      if (type === "step:after" && index === 0) {
        dispatcher(setTourLocation(4));
        navigate("/jp/job-positions");
        return;
      }
    }

    //**^^** ADMIN  **^^**//
    if (type === "step:after") {
      // Step 0: Wait for popover to render before proceeding to step 1
      if (index === 0) {
        // Wait for popover to render and find users-list element
        setTimeout(() => {
          const usersListElement = document.querySelector(".users-list");

          if (usersListElement) {
            dispatcher(setStepIndex(1));
          } else {
            // Retry after a short delay
            setTimeout(() => {
              dispatcher(setStepIndex(1));
            }, 500);
          }
        }, 300);
        return;
      }

      // Step 1: Move to step 2 (users-list step)
      if (index === 1) {
        // Ensure popover is still open
        if (!open) {
          setOpen(true);
        }

        // Check if users-list element exists
        const usersListElement = document.querySelector(".users-list");

        if (usersListElement) {
          dispatcher(setStepIndex(2));
        } else {
          // Wait for element to render
          setTimeout(() => {
            dispatcher(setStepIndex(2));
          }, 500);
        }
        return;
      }

      // Step 2: Move to step 3 (continue button step)
      if (index === 2) {
        dispatcher(setStepIndex(3));
        return;
      }

      // Step 3: Auto redirect to users page
      if (index === 3) {
        // Add a small delay before redirect to ensure tour completes
        setTimeout(() => {
          setOpen(false);
          dispatcher(setTourLocation(2));
          navigate("/settings/user-settings");
        }, 300);
        return;
      }

      // Default: just advance to next step
      dispatcher(setStepIndex(index + 1));
    }

    // Tour finished or skipped
    if (
      user_info?.role_name === "Org Admin" ||
      user_info?.role_name === "Recruiter Manager"
    ) {
      if (status === "finished" || status === "skipped") {
        if (isUpdatingTour.current) {
          return;
        }
        isUpdatingTour.current = true;

        try {
          if (checked) {
            await axios.put(updateTourUrlConstruct(), {
              user_id: user_info?.id,
              attr_value: status === "finished" ? "COMPLETED" : "SKIPPED",
            });
          } else {
          }
        } catch (err) {
        } finally {
          isUpdatingTour.current = false;
          setOpen(false);
          dispatcher(setStepIndex(0));
        }
      }
    }

    // Skip button clicked
    if (action === "skip") {
      setOpen(false);
      dispatcher(stopTour());
      dispatcher({
        type: TOUR_LOCATION,
        payload: { tourStatus: "SKIPPED" },
      });
    }
  };

  const handleTourCompleted = async () => {
    if (checked) {
      await updateTourStatus("COMPLETED");
    }
    dispatcher({ type: TOUR_LOCATION, payload: { tourStatus: "COMPLETED" } });
  };

  const handleTourSkipped = async () => {
    if (checked) {
      await updateTourStatus("SKIPPED");
    }
    dispatcher({ type: TOUR_LOCATION, payload: { tourStatus: "SKIPPED" } });
  };

  const updateTourStatus = async (value) => {
    if (isUpdatingTour.current) return;
    isUpdatingTour.current = true;
    try {
      await axios.put(updateTourUrlConstruct(), {
        user_id: user_info?.id,
        attr_value: value,
      });
    } catch (err) {
    } finally {
      isUpdatingTour.current = false;
    }
  };

  return (
    <>
      <Chip
        sx={{
          height: "48px",
          alignItems: "center",
          borderRadius: "27px",
          transition: "all .2s ease-in-out",
          borderColor: theme.palette.primary.light,
          backgroundColor: theme.palette.primary.light,
          '&[aria-controls="menu-list-grow"], &:hover': {
            borderColor: theme.palette.primary.main,
            background: `${theme.palette.primary.main}!important`,
            color: theme.palette.primary.light,
            "& svg": {
              stroke: theme.palette.primary.light,
            },
          },
          "& .MuiChip-label": {
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: {
              xs: 160,
              sm: 220,
              md: "none",
            },
          },
        }}
        icon={
          <Avatar
            src={`data:image/jpeg;base64,${userLogo}`}
            sx={{
              ...theme.typography.mediumAvatar,
              margin: "8px 0 8px 8px !important",
              cursor: "pointer",
            }}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            color="inherit"
          />
        }
        label={
          <div style={{ display: "flex", alignItems: "center" }}>
            <div sx={{ ml: 3 }}>
              {user_info != null ? (
                <Typography
                  sx={{
                    ml: -1,
                    my: 2,
                    fontWeight: "bold",
                    fontFamily: "Arial, sans-serif",
                    fontSize: 17,
                    color: "text.primary",
                    textShadow: "1px 1px 1px rgba(0, 0, 0, 0.3)",
                    borderRadius: 4,
                    padding: "8px",
                  }}
                >
                  {user_info?.role_name == null && user_info?.id === AD_ID
                    ? `${companyName} - Administrator`
                    : user_info?.role_name == "Org Admin"
                    ? `${companyName} - Org Admin`
                    : user_info?.name}
                </Typography>
              ) : null}
            </div>
            <IconSettings
              stroke={1.5}
              size="1.5rem"
              color={theme.palette.primary.main}
            />
          </div>
        }
        variant="outlined"
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleClickToggle}
        color="primary"
        className="profile-chip"
      />

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 14],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard
                  border={false}
                  elevation={16}
                  content={false}
                  boxShadow
                  shadow={theme.shadows[16]}
                >
                  <Box sx={{ p: 2 }}>
                    {user_info != null ? (
                      <>
                        <Stack
                          direction="row"
                          sx={{ marginTop: 1, marginBottom: 2 }}
                        >
                          <div
                            style={{ marginRight: "8px", marginLeft: "8px" }}
                          >
                            <Tooltip title="email" placement="top-end">
                              <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 700, fontSize: 16 }}
                              >
                                {user_info?.email != false
                                  ? user_info?.name
                                  : user_info?.name}
                              </Typography>
                              <Typography>
                                {user_info?.email != false
                                  ? user_info?.email
                                  : ""}
                              </Typography>
                            </Tooltip>
                          </div>
                        </Stack>
                        <Stack
                          direction="row"
                          sx={{ ml: 1, mt: -1, marginBottom: 1 }}
                        >
                          <div>
                            <Tooltip title="Role" placement="bottom-end">
                              <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 500, fontSize: 14 }}
                              >
                                {user_info?.role_name == null &&
                                user_info?.id === AD_ID
                                  ? "Administrator"
                                  : user_info?.role_name == "Recruiter Manager"
                                  ? "Recruiter Manager"
                                  : user_info?.role_name == "Recruiter"
                                  ? "Recruiter"
                                  : user_info?.role_name == "Org Admin"
                                  ? "Org Admin"
                                  : user_info?.role_name}
                              </Typography>
                              { /*{isDatePassed && (
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: 900, fontSize: 14 }}
                                  display={"inline"}
                                  color="error"
                                >
                                  Plan Expired
                                </Typography>
                              )} */}

                              {isBasicPlan ? (
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: 900, fontSize: 14 }}
                                  display="inline"
                                  color="warning.main"
                                >
                                  Upgrade Plan
                                </Typography>
                              ) : (
                                isDatePassed && (
                                  <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: 900, fontSize: 14 }}
                                    display="inline"
                                    color="error"
                                  >
                                    Plan Expired
                                  </Typography>
                                )
                              )}
                              
                            </Tooltip>
                          </div>
                        </Stack>
                      </>
                    ) : null}
                    <Divider />
                  </Box>
                  <PerfectScrollbar
                    style={{
                      height: "100%",
                      maxHeight: "calc(100vh - 250px)",
                      overflowX: "hidden",
                    }}
                  >
                    <Box sx={{ p: 2, mt: -4 }}>
                      <List
                        component="nav"
                        sx={{
                          width: "100%",
                          maxWidth: 350,
                          minWidth: 300,
                          backgroundColor: theme.palette.background.paper,
                          borderRadius: "10px",
                          [theme.breakpoints.down("md")]: {
                            minWidth: "100%",
                          },
                          "& .MuiListItemButton-root": {
                            mt: 1.2,
                          },
                        }}
                      >
                        {user_info != null ? (
                          <>
                            <ListItemButton
                              sx={{
                                borderRadius: `${customization.borderRadius}px`,
                              }}
                              selected={menuItem === 6}
                              onClick={(event) =>
                                handleListItemClick(event, 6, "#")
                              }
                            >
                              <ListItemIcon>
                                <IconSettingsAutomation
                                  stroke={1.5}
                                  size="1.3rem"
                                />
                              </ListItemIcon>
                              <Grid className="hiredrate-settings">
                                <ListItemText
                                  primary={
                                    <Typography variant="body2">
                                      Hiredrate Settings
                                    </Typography>
                                  }
                                />
                              </Grid>
                            </ListItemButton>
                            <ListItemButton
                              sx={{
                                borderRadius: `${customization.borderRadius}px`,
                              }}
                              selected={menuItem === 0}
                              onClick={(event) =>
                                handleListItemClick(event, 0, "#")
                              }
                            >
                              <ListItemIcon>
                                <IconSettings stroke={1.5} size="1.3rem" />
                              </ListItemIcon>
                              <Grid className="account-settings">
                                <ListItemText
                                  primary={
                                    <Typography variant="body2">
                                      Account Settings
                                    </Typography>
                                  }
                                />
                              </Grid>
                            </ListItemButton>
                            {user_info?.role_name == null ||
                            user_info?.role_name == "Org Admin" ? (
                              <ListItemButton
                                sx={{
                                  borderRadius: `${customization.borderRadius}px`,
                                }}
                                selected={menuItem === 2}
                                onClick={(event) =>
                                  handleListItemClick(event, 2, "#")
                                }
                              >
                                <ListItemIcon>
                                  <IconBuildingBank
                                    stroke={1.5}
                                    size="1.3rem"
                                  />
                                </ListItemIcon>
                                <Grid className="company">
                                  <ListItemText
                                    primary={
                                      <Typography variant="body2">
                                        Company
                                      </Typography>
                                    }
                                  />
                                </Grid>
                              </ListItemButton>
                            ) : null}
                            {user_info?.role_name == null ||
                            user_info?.role_name == "Org Admin" ||
                            user_info?.role_name == "Recruiter Manager" ? (
                              <ListItemButton
                                sx={{
                                  borderRadius: `${customization.borderRadius}px`,
                                }}
                                selected={menuItem === 1}
                                onClick={(event) =>
                                  handleListItemClick(event, 1, "#")
                                }
                                className="users-list" // Target class for Joyride
                              >
                                <ListItemIcon>
                                  <IconUsers stroke={1.5} size="1.3rem" />
                                </ListItemIcon>
                                <Grid className="users">
                                  <ListItemText
                                    primary={
                                      <Typography variant="body2">
                                        Users
                                      </Typography>
                                    }
                                  />
                                </Grid>
                              </ListItemButton>
                            ) : null}
                          </>
                        ) : null}
                        <ListItemButton
                              // sx={{
                              //   borderRadius: ${customization.borderRadius}px,
                              // }}
                              selected={menuItem === 6}
                              onClick={(event) =>
                                handleListItemClick(event, 9, "#")
                              }
                            >
                              <ListItemIcon>
                                <IconSettingsAutomation
                                  stroke={1.5}
                                  size="1.3rem"
                                />
                              </ListItemIcon>
                              <Grid className="hiredrate-settings">
                                <ListItemText
                                  primary={
                                    <Typography variant="body2">
                                      Subscription
                                    </Typography>
                                  }
                                />
                              </Grid>
                            </ListItemButton>
                        <ListItemButton
                          sx={{
                            borderRadius: `${customization.borderRadius}px`,
                          }}
                          onClick={handleLogout2}
                        >
                          <ListItemIcon>
                            <IconLogout stroke={1.5} size="1.3rem" />
                          </ListItemIcon>
                          <Grid className="logout">
                            <ListItemText
                              primary={
                                <Typography variant="body2">Logout</Typography>
                              }
                            />
                          </Grid>
                        </ListItemButton>
                      </List>
                    </Box>
                  </PerfectScrollbar>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>

      {isTourOpen && user_info?.role_name === "Org Admin" && (
        <Joyride
          steps={steps}
          continuous
          showSkipButton
          run={run}
          callback={async (data) => {
            const { action, index, type, status } = data;

            // 1. Tour fully ended (either completed or skipped via button)
            if (type === "tour:end") {
              if (status === "finished") {
                await handleTourCompleted();
              } else if (status === "skipped") {
                await handleTourSkipped();
              }
              // dispatcher(stopTour());
              dispatcher(setStepIndex(0));
              setOpen(false);
              return;
            }

            // User clicked "Skip" mid-tour
            if (action === "skip") {
              await handleTourSkipped();
              dispatcher(stopTour());
              setOpen(false);
              return;
            }

            // User clicked "Close" (X button)
            if (action === "close") {
              await handleTourSkipped();
              dispatcher(stopTour());
              setOpen(false);
              return;
            }

            // 4. Step transition: Next or Back
            if (type === "step:after") {
              handleTourEnd(data);
            }
          }}
          disableScrolling
          scrollToFirstStep
          disableOverlayClose={true}
          hideCloseButton={false}
          spotlightPadding={5}
          floaterProps={{
            styles: {
              floater: {
                filter: "none",
              },
            },
          }}
          styles={{
            options: {
              zIndex: 10000,
              primaryColor: theme.palette.primary.main,
            },
            // Removes Joyride's default wrapper padding (the 20px 10px you're seeing)
            tooltip: {
              padding: 0,
            },

            // tooltipContainer: {
            //   padding: "24px 24px 24px 24px",
            // },
            tooltipFooter: {
              padding: "24px 24px",
              margin: 0,
              boxSizing: "border-box",
            },
            buttonNext: {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "0.875rem",
              lineHeight: 1.75,
            },
            buttonBack: {
              marginRight: isMobile?"20px":"33px",
              backgroundColor:  theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "0.875rem",
              lineHeight: 1.75,
            },
            buttonClose: {
              backgroundColor: "transparent",
              color: theme.palette.error.main,
              borderRadius: "4px",
              padding: "3px 6px",
              margin: "16px 16px",
              border: `1px solid ${theme.palette.error.main}`,
            },
            buttonSkip: {
              backgroundColor: "transparent",
              border: `1px solid ${theme.palette.error.main}`,
              color: theme.palette.error.main,
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "0.875rem",
              lineHeight: 1.75,
              marginRight:isMobile?"20px":"0px"
            },
            tooltipContainer: {
              textAlign: "left",
            },
          }}
          locale={{
            back: "Previous",
            close: "Close",
            last: "Finish",
            next: "Continue",
            skip: "Skip Tour",
          }}
        />
      )}
    </>
  );
};

export default ProfileSection;
